import BaseUseCase from "../../base_use_case.js";
class ListMenusUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/menus/menus`,
      params: params
    });
  }
}

const instance = new ListMenusUseCase();
export default instance;
